import React from 'react';
import styles from './Recipes.module.scss';
import Card from '../../../Workflow/LocalComponents/Card';

const Recipes = ({ api, workflowMap, onWorkflowClick }) => {
  if (!api || !workflowMap) {
    return null;
  }

  const getRelevantWorkflows = () => {
    const apiPath = api.path;
    const apiMethod = api.method.toLowerCase();
    const relevantWorkflows = new Set();

    Object.entries(workflowMap).forEach(([workflowName, workflowDetails]) => {
      if (workflowDetails.endpoints) {
        workflowDetails.endpoints.forEach(endpoint => {
          const workflowMethod = endpoint.method.replace(/^http/i, '').toLowerCase();
          if (endpoint.url === apiPath && workflowMethod === apiMethod) {
            relevantWorkflows.add(workflowDetails.workflow);
          }
        });
      }
    });

    return Array.from(relevantWorkflows);
  };

  const relevantWorkflows = getRelevantWorkflows();

  if (relevantWorkflows.length === 0) {
    return null;
  }

  const icons = ["api", "storage", "receipt_long", "dns", "cloud_queue", "support_agent", "gavel", "card_membership", "price_check"];

  return (
    <div className={styles.recipesSection}>
      <h5 className='mb-4'>RECIPES</h5>
      <div className={styles.cardGrid}>
        {relevantWorkflows.map((workflow, index) => (
          <Card
            key={index}
            icon={icons[index % icons.length]}
            title={workflow.displayText.includes(' - ') ? workflow.displayText.split(' - ').slice(1).join(' - ') : workflow.displayText}
            onClick={() => onWorkflowClick(workflow, icons[index % icons.length])}
            variant="recipe"
          />
        ))}
      </div>
    </div>
  );
};

export default Recipes;